"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNotificationDigestScheduleDto = instanceOfNotificationDigestScheduleDto;
exports.NotificationDigestScheduleDtoFromJSON = NotificationDigestScheduleDtoFromJSON;
exports.NotificationDigestScheduleDtoFromJSONTyped = NotificationDigestScheduleDtoFromJSONTyped;
exports.NotificationDigestScheduleDtoToJSON = NotificationDigestScheduleDtoToJSON;
exports.NotificationDigestScheduleDtoToJSONTyped = NotificationDigestScheduleDtoToJSONTyped;
/**
 * Check if a given object implements the NotificationDigestScheduleDto interface.
 */
function instanceOfNotificationDigestScheduleDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('label' in value) || value['label'] === undefined)
        return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined)
        return false;
    return true;
}
function NotificationDigestScheduleDtoFromJSON(json) {
    return NotificationDigestScheduleDtoFromJSONTyped(json, false);
}
function NotificationDigestScheduleDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'label': json['label'],
        'isDefault': json['isDefault'],
    };
}
function NotificationDigestScheduleDtoToJSON(json) {
    return NotificationDigestScheduleDtoToJSONTyped(json, false);
}
function NotificationDigestScheduleDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'label': value['label'],
        'isDefault': value['isDefault'],
    };
}
//# sourceMappingURL=NotificationDigestScheduleDto.js.map